function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import CurrencyAdornment from './CurrencyAdornment';
import TextBox from './TextBox';
import '../assets/inputFields.css';
const PriceBox = props => /*#__PURE__*/React.createElement(TextBox, _extends({
  type: "number",
  step: ".01"
}, props, {
  key: props?.customKey || props?.name || +new Date(),
  InputProps: {
    startAdornment: /*#__PURE__*/React.createElement(CurrencyAdornment, null)
  }
}));
PriceBox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number
};
export default PriceBox;